<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <!-- Data Peserta -->
  <CCardBody>
    <CRow>
      <div class="col-sm-12 col-xl-6">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Periode</label>
          <multiselect
            class="multi-select"
            label="tahun"
            placeholder="Pilih Periode"
            :show-labels="false"
            required
            v-model="periode"
            @select="changePeriode"
            :options="dataTahun"
          ></multiselect>
        </div>
      </div>
      <div class="col-sm-12 col-xl-6">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Kategori Anggota</label>
          <multiselect
            class="multi-select"
            label="namaKategori"
            placeholder="Pilih Kategori Anggota"
            :show-labels="false"
            required
            v-model="namaKategori"
            @select="changeSertifikasi"
            :options="dataSertifikasi"
          ></multiselect>
        </div>
      </div>

      <div class="col-sm-12 col-xl-12">
        <div style="float: left">
          <template v-if="role_status && role_status.status_export_excel">
          <button class="btn btn-info" @click="download">
            Download Data Pembayaran
          </button>
          </template>
        </div>
        <div style="float: right">
          <button class="btn btn-info mr-2" @click="resetFilter">
            Reset Filter
          </button>
          <button class="btn btn-success" @click="changePelatihan">
            Terapkan Filter
          </button>
        </div>
      </div>
    </CRow>
  </CCardBody>
  <!-- End Data Peserta -->
</template>

<script>
import PeriodeService from "@/services/datamaster/periode-iuran.service";
import PaymentService from "@/services/finance/payment.service";
import KategoriAnggotaService from '@/services/keanggotaan/kategori-anggota.service';
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import { KategoriAnggota } from "@/mixins/master/KategoriAnggota";
import { exportUtils } from '@/mixins/exportUtils';

export default {
  mixins: [AlertUtils, Pagination, KategoriAnggota, AlertUtils],  
  data() {
    return {
      formFilter: {
        periode: "",
        value: "",
        idKategoriAnggota: "",
        status_pembayaran: "",
        tipe: 'pembayaran_anggota',
      },
      namaKategori: "",
      periode: "",
      tipe: 'pembayaran_anggota',
      kategori_anggota: "",
      dataSertifikasi: [],
      items: [],
      dataPelatihan: [],
      dataTahun: [],      
      collapseDuration: 0,
      content: [],
      role_status: null
    };
  },

  mounted() {
    this.roleData();
    this.getAllKategoriAnggota();
    this.getPeriode('0', 10000, 'default');
    this.getAllKategoriAnggota();
  },

  methods: {
     roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === '/keuangan/pembayaran' );  
      this.role_status = data;
    },
    changeSertifikasi(value) {
      this.formFilter.idKategoriAnggota = value.idKategoriAnggota;      
    },

    filterData() {
      this.$parent.filterData(this.formFilter);
    },

    resetFilter() {      
      this.periode = "";
      this.namaKategori = "";
      $("#filterStatusPembayaran").val("");
    },    

    getPeriode(currentPage, pageSize, filter) {
      PeriodeService.getPeriode(currentPage, pageSize, filter)
        .then((response) => {
          this.dataTahun = response.data.data.content;
          var periode = this.dataTahun.find((el) => el.status === "1");
          this.periode = {
            tahun: periode.tahun,
            tahun: periode.tahun
            };
          this.formFilter.periode = periode.tahun;
          this.getKategoriAnggota()
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getKategoriAnggota() {
      KategoriAnggotaService.getKategoriAnggota(0, 100000, "default")
        .then((response) => {
          this.dataSertifikasi = response.data.data.content;

          if (localStorage.getItem('formFilterKeanggotaan')) {
            this.formFilter = JSON.parse(localStorage.getItem('formFilterKeanggotaan'))
          } else {
            this.formFilter.idKategoriAnggota = this.dataSertifikasi[0].idKategoriAnggota          
            var value = {
              id : this.formFilter.idKategoriAnggota,
              periode : this.formFilter.periode,
            }
          }

          if (localStorage.getItem('namaKategori')) {
            this.namaKategori = JSON.parse(localStorage.getItem('namaKategori'))
          } else {
            this.namaKategori = {
              namaKategori : this.dataSertifikasi[0].namaKategori
            }                   
          }
            
          var data = {
            namaKategori: 'Semua',
            idKategoriAnggota: 'default'
          }

          this.dataSertifikasi.unshift(data);
          this.changePelatihan(value);
        })
        .catch((error) => {
          onsole.log(error);
        });
    },

    changePelatihan(value) {
      localStorage.setItem('formFilterKeanggotaan', JSON.stringify(this.formFilter));
      localStorage.setItem('namaKategori', JSON.stringify(this.namaKategori));
      var value = {
        id : this.formFilter.idKategoriAnggota,
        periode : this.formFilter.periode,
      }
      this.$parent.changePelatihan(value);
      
    },

    changePeriode(value) {
      this.formFilter.periode = value.tahun
    },

    download(value) {
      var value = {
        id : this.formFilter.idKategoriAnggota,
        periode : this.formFilter.periode,
      }
      this.$parent.download(value);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
